import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=68c2c2fa&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.scss?vue&type=style&index=0&id=68c2c2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2c2fa",
  null
  
)

export default component.exports